export default __webpack_public_path__ + "static/media/tsi_help3.b0f2056e.png";